<template>
  <MissionContainer :header-url="mission.module.config.media_url + mission.module_id + '/thumbnail'">
    <h1 style="margin-bottom: 30px">{{mission.module.config.label}}</h1>

    <div class="ContextBlockSpec">
      <p>Bienvenue dans le parcours Nutrition ! Le test que nous vous proposons dans cette mission, correspond aux nouvelles recommandations officielles de Santé Publique France en matière de nutrition.</p>
      <p>Une bonne nutrition contribue à la préservation d'un bon état de santé, et réduit notamment les risques de certaines maladies chroniques telles que l'obésité, les maladies cardiovasculaires, certains cancers, le diabète de type 2 ou la dénutrition.</p>
      <p>Prenez le temps de répondre et ne trichez pas ! L'analyse des résultats à ce test permettra de vous donner des conseils précieux pour adapter votre alimentation pour une meilleure santé.</p>
    </div>

    <p class="ObjectiveBlockSpec">
      <b class="primary--text">Objectif : </b>
      Définir vos habitudes alimentaires.
    </p>

    <div class="InstructionsBlockSpec">
      Pour réaliser cette mission, vous devez :<br/>
      <ol>
        <li>Regarder la vidéo</li>
        <li>Répondre au quiz</li>
        <li>VALIDER la mission</li>
      </ol>
    </div>

    <IriadeApplicationMediaBlock :block="{ config: mission.module.config.block_media }"></IriadeApplicationMediaBlock>

    <div style="background: #F8F8F8; border-radius: 12px; padding: 55px 25px; margin-bottom: 30px;" class="mt-5">
      <div v-show="ui.step === 'q1a'">
        <p class="Question">
          Je prends un petit déjeuner :
        </p>

        <v-radio-group v-model="missionData.quiz.q1a">
          <v-radio :value="0" label="Le plus souvent (au moins 6 jours sur 7)"/>
          <v-radio :value="1" label="Plus rarement (entre 1 et 5 fois par semaine)"/>
          <v-radio :value="2" label="Jamais"/>
        </v-radio-group>

        <v-btn @click="step('q1b')"
               :disabled="missionData.quiz.q1a === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q1b'">
        <p class="Question">
          Je prends un déjeuner :
        </p>

        <v-radio-group v-model="missionData.quiz.q1b">
          <v-radio :value="0" label="Le plus souvent (au moins 6 jours sur 7)"/>
          <v-radio :value="1" label="Plus rarement (entre 1 et 5 fois par semaine)"/>
          <v-radio :value="2" label="Jamais"/>
        </v-radio-group>

        <v-btn @click="step('q1c')"
               :disabled="missionData.quiz.q1b === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q1c'">
        <p class="Question">
          Je prends un diner :
        </p>

        <v-radio-group v-model="missionData.quiz.q1c">
          <v-radio :value="0" label="Le plus souvent (au moins 6 jours sur 7)"/>
          <v-radio :value="1" label="Plus rarement (entre 1 et 5 fois par semaine)"/>
          <v-radio :value="2" label="Jamais"/>
        </v-radio-group>

        <v-btn @click="step('q2a')"
               :disabled="missionData.quiz.q1c === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q2a'">
        <p class="Question">
          Habituellement, prenez-vous un dessert ?
        </p>

        <v-radio-group v-model="missionData.quiz.q2a">
          <v-radio :value="0" label="Oui"/>
          <v-radio :value="1" label="Non"/>
        </v-radio-group>

        <v-btn @click="step(missionData.quiz.q2a === 0 ? 'q2b' : 'q3a')"
               :disabled="missionData.quiz.q2a === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q2b'">
        <p class="Question">
          Quel dessert prenez-vous habituellement ?
        </p>

        <v-radio-group v-model="missionData.quiz.q2b">
          <v-radio :value="0" label="Fruit, compote"/>
          <v-radio :value="1" label="Pâtisserie (gâteau, glace...)"/>
          <v-radio :value="2" label="Laitage nature"/>
          <v-radio :value="3" label="Laitage sucré, crème dessert, dessert lacté (viennois...)"/>
          <v-radio :value="4" label="Fromage"/>
        </v-radio-group>

        <v-btn @click="step(missionData.quiz.q2b === 4 ? 'q2c' : 'q3a')"
               :disabled="missionData.quiz.q2b === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q2c'">
        <p class="Question">
          Quelle quantité de fromage prenez-vous par jour ?
        </p>
        <v-radio-group v-model="missionData.quiz.q2c">
          <v-radio :value="0" label="30 grammes"/>
          <v-radio :value="1" label="60 grammes"/>
          <v-radio :value="2" label="90 grammes"/>
        </v-radio-group>

        <v-btn @click="step('q3a')"
               :disabled="missionData.quiz.q2c === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q3a'">
        <p class="Question">
          Je mange de la viande, des œufs, ou du poisson :
        </p>

        <v-radio-group v-model="missionData.quiz.q3a">
          <v-radio :value="0" label="Tous les jours"/>
          <v-radio :value="1" label="Quelques fois par semaine"/>
          <v-radio :value="2" label="Rarement ou pas du tout"/>
        </v-radio-group>

        <v-btn @click="step('q3b')"
               :disabled="missionData.quiz.q3a === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q3b'">
        <p class="Question">
          Je mange des légumineuses ?
        </p>

        <v-radio-group v-model="missionData.quiz.q3b">
          <v-radio :value="0" label="2 fois ou moins par semaine"/>
          <v-radio :value="1" label="Plus de 2 fois par semaine"/>
        </v-radio-group>

        <v-btn @click="step('q4')"
               :disabled="missionData.quiz.q3b === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q4'">
        <p class="Question">
          Le plus souvent, je consomme des laitages ?
        </p>

        <v-radio-group v-model="missionData.quiz.q4"
                       v-if="mission.module.config.age <= 65">
          <v-radio :value="0" label="2 fois ou plus par jour"/>
          <v-radio :value="1" label="Moins de 2 fois par jour"/>
        </v-radio-group>
        <v-radio-group v-model="missionData.quiz.q4"
                       v-else>
          <v-radio :value="0" label="3 fois ou plus par jour"/>
          <v-radio :value="1" label="Moins de 3 fois par jour"/>
        </v-radio-group>

        <v-btn @click="step('q6')"
               :disabled="missionData.quiz.q4 === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q6'">
        <p class="Question">
          La plupart du temps, vous mangez des légumes (frais, surgelé, en conserve) ?
        </p>

        <v-radio-group v-model="missionData.quiz.q6">
          <v-radio :value="0" label="Au déjeuner et au diner"/>
          <v-radio :value="1" label="Au déjeuner seulement"/>
          <v-radio :value="2" label="Au diner seulement"/>
        </v-radio-group>

        <v-btn @click="step('q7')"
               :disabled="missionData.quiz.q6 === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q7'">
        <p class="Question">
          Je mange de la charcuterie
        </p>

        <v-radio-group v-model="missionData.quiz.q7">
          <v-radio :value="0" label="2 fois par semaine ou moins"/>
          <v-radio :value="1" label="Plus de 2 fois par semaine"/>
        </v-radio-group>

        <v-btn @click="step('q8')"
               :disabled="missionData.quiz.q7 === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q8'">
        <p class="Question">
          Je mange des plats du commerce (surgelés, sous vide...), des quiches ou de la pizza :
        </p>

        <v-radio-group v-model="missionData.quiz.q8">
          <v-radio :value="0" label="3 fois par semaine ou moins"/>
          <v-radio :value="1" label="Plus de 3 fois par semaine"/>
        </v-radio-group>

        <v-btn @click="step('q9')"
               :disabled="missionData.quiz.q8 === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q9'">
        <p class="Question">
          Je consomme des produits type « fastfood »
        </p>

        <v-radio-group v-model="missionData.quiz.q9">
          <v-radio :value="0" label="2 fois par semaine ou moins"/>
          <v-radio :value="1" label="Plus de 2 fois par semaine"/>
        </v-radio-group>

        <v-btn @click="step('q10a')"
               :disabled="missionData.quiz.q9 === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q10a'">
        <p class="Question">
          La plupart du temps, vous mangez des féculents ?
        </p>

        <v-radio-group v-model="missionData.quiz.q10a">
          <v-radio :value="0" label="Aux 3 repas (petit déjeuner, déjeuner et diner)"/>
          <v-radio :value="1" label="A 2 repas ou moins"/>
        </v-radio-group>

        <v-btn @click="step('q10b')"
               :disabled="missionData.quiz.q10a === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q10b'">
        <p class="Question">
          La plupart du temps, vous mangez des féculents complets ?
        </p>

        <v-radio-group v-model="missionData.quiz.q10b">
          <v-radio :value="0" label="Plus d’une fois par jour"/>
          <v-radio :value="1" label="Une fois par jour ou moins"/>
        </v-radio-group>

        <v-btn @click="step('q11a')"
               :disabled="missionData.quiz.q10b === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q11a'">
        <p class="Question">
          En général, vous buvez des boissons sucrées (jus de fruit compris, même 100% pur jus)
        </p>

        <v-radio-group v-model="missionData.quiz.q11a">
          <v-radio :value="0" label="Plus d’une fois par jour"/>
          <v-radio :value="1" label="Une fois par jour"/>
          <v-radio :value="2" label="Moins d’une fois par jour"/>
        </v-radio-group>

        <v-btn @click="step('q11b')"
               :disabled="missionData.quiz.q11a === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q11b'">
        <p class="Question">
          En général, vous mangez des biscuits, des bonbons, des barres chocolatées ?
        </p>

        <v-radio-group v-model="missionData.quiz.q11b">
          <v-radio :value="0" label="Plus d’une fois par jour"/>
          <v-radio :value="1" label="Une fois par jour"/>
          <v-radio :value="2" label="Moins d’une fois par jour"/>
        </v-radio-group>

        <v-btn @click="step('q11c')"
               :disabled="missionData.quiz.q11b === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q11c'">
        <p class="Question">
          Combien de portions de fruits frais ou de compotes sans sucre ajouté mangez-vous par jour ?
        </p>

        <v-radio-group v-model="missionData.quiz.q11c">
          <v-radio :value="0" label="Plus de 2"/>
          <v-radio :value="1" label="1 ou 2"/>
          <v-radio :value="2" label="Moins d’une fois par jour"/>
        </v-radio-group>

        <v-btn @click="step('q12')"
               :disabled="missionData.quiz.q11c === null">Suite
        </v-btn>
      </div>

      <div v-show="ui.step === 'q12'">
        <p class="Question">
          Habituellement, je bois de l’alcool ?
        </p>

        <v-radio-group v-model="missionData.quiz.q12">
          <v-radio :value="0" label="Moins de 2 verres standards par semaine"/>
          <v-radio :value="1" label="Environ 2 verres standards par jour et pas tous les jours"/>
          <v-radio :value="2" label="2 verres standards ou plus par jour"/>
        </v-radio-group>

        <v-btn @click="step('results')"
               :disabled="missionData.quiz.q12 === null">Résultats
        </v-btn>
      </div>

      <div v-show="ui.step === 'results'">

        Vos réponses au test nous ont permis d'établir une liste de points à améliorer en Nutrition, comme suit :

        <div class="Info"
             v-if="missionData.quiz.q1a + missionData.quiz.q1b + missionData.quiz.q1c > 0">
          Manger plus régulièrement
        </div>

        <div class="Info"
             v-if="missionData.quiz.q2b === 1 || missionData.quiz.q2b === 3 || score11A === 3 || (score11A === 1 && score11B === 2) || (score11A === 1 && score11B === 1) || score11B === 3">
          Mangez moins sucré
        </div>

        <div class="Info"
             v-if="missionData.quiz.q2c > 0 || missionData.quiz.q7 === 1 || missionData.quiz.q8 === 1 || missionData.quiz.q9 === 1">
          Mangez moins gras, moins salé
        </div>

        <div class="Info"
             v-if="missionData.quiz.q11c === 2 || missionData.quiz.q6 > 0">
          Mangez plus de fruits et légumes
        </div>

        <div class="Info"
             v-if="(missionData.quiz.q3a === 1 && missionData.quiz.q3b === 0) || missionData.quiz.q3a === 2">
          Mangez plus de protéine
        </div>

        <div class="Info"
             v-if="(missionData.quiz.q3a === 1 && missionData.quiz.q3b === 0) || missionData.quiz.q3b === 0">
          Mangez plus de légumineuse
        </div>

        <div class="Info"
             v-if="missionData.quiz.q4 === 1">
          Mangez plus de produits laitiers
        </div>

        <div class="Info"
             v-if="missionData.quiz.q10a === 1 || missionData.quiz.q10b === 1">
          Mangez plus de féculents
        </div>

        <div class="Info"
             v-if="missionData.quiz.q12 === 2">
          Buvez moins d’alcool
        </div>


        <v-btn @click="step('fin')">Fin</v-btn>
      </div>

      <!------------------------------------------------------------------------------------>

      <div v-show="ui.step === 'fin'">
        <div class="Info">
          Merci d'avoir répondu à ce questionnaire.<br/>
          Vous pourrez retrouver l'analyse de vos réponses dans votre médiathèque.
        </div>

        <p class="primary--text" style="font-size: 15px; font-style: italic">Appuyer sur « Valider la mission » pour
          valider et enregistrer ce questionnaire</p>

        <FinishMissionButtonBlock class="mt-10"
                                  @click.native="finishMission">Valider la mission
        </FinishMissionButtonBlock>
      </div>
    </div>
  </MissionContainer>
</template>

<script>
  import api from 'api'
  import FinishMissionButtonBlock from 'components/blocks/FinishMissionButtonBlock'
  import MissionContainer from 'components/blocks/MissionContainer'
  import IriadeApplicationMediaBlock
    from "../../../../../../Iriade/Blocks/IriadeApplicationMediaBlock/IriadeApplicationMediaBlock";

  export default {
    components: {
      IriadeApplicationMediaBlock,
      FinishMissionButtonBlock,
      MissionContainer
    },
    data () {
      return {
        missionData: {
          quiz: {
            q1a: null,
            q1b: null,
            q1c: null,
            q2a: null,
            q2b: null,
            q2c: null,
            q3a: null,
            q3b: null,
            q4: null,
            q6: null,
            q7: null,
            q8: null,
            q9: null,
            q10a: null,
            q10b: null,
            q11a: null,
            q11b: null,
            q11c: null,
            q12: null,
          },
          analyse: {
            repas: false,
            sucre: false,
            gras: false,
            fruit: false,
            proteine: false,
            sec: false,
            laitier: false,
            feculent: false,
            alcool: false,
          },
        },
        ui: {
          step: 'q1a'
        },
        patient: null,
      }
    },

    computed: {
      score11A() {
        return (this.missionData.quiz.q11a === 0) + (this.missionData.quiz.q11b === 0) + (this.missionData.quiz.q11c === 0);
      },

      score11B() {
        return (this.missionData.quiz.q11a === 1) + (this.missionData.quiz.q11b === 1) + (this.missionData.quiz.q11c === 1);
      },
    },

    methods: {
      finishMission () {
        this.ui.loading = true
        this.errors = {}

        this.updateData();

        api.post(`missions/${this.mission.id}`, this.missionData)
          .then(res => {
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
            this.$router.push({name: 'patient@dashboard'})
          })
          .catch(err => {
            this.$mango.snackbar({
              color: 'error',
              text: "Erreur de validation. Veuillez vérifier le formulaire."
            })
          })
          .then(() => {
            this.ui.loading = false
          })
      },

      step (target) {
        this.ui.step = target;
      },

      updateData() {
        if (this.missionData.quiz.q1a + this.missionData.quiz.q1b + this.missionData.quiz.q1c > 0) {
          this.missionData.analyse.repas = true;
        }
        if (this.missionData.quiz.q2b === 1 || this.missionData.quiz.q2b === 3 || this.score11A === 3 || (this.score11A === 1 && this.score11B === 2) || (this.score11A === 1 && this.score11B === 1) || this.score11B === 3) {
          this.missionData.analyse.sucre = true;
        }
        if (this.missionData.quiz.q2c > 0 || this.missionData.quiz.q7 === 1 || this.missionData.quiz.q8 === 1 || this.missionData.quiz.q9 === 1) {
          this.missionData.analyse.gras = true;
        }
        if (this.missionData.quiz.q11c === 2 || this.missionData.quiz.q6 > 0) {
          this.missionData.analyse.fruit = true;
        }
        if ((this.missionData.quiz.q3a === 1 && this.missionData.quiz.q3b === 0) || this.missionData.quiz.q3a === 2) {
          this.missionData.analyse.proteine = true;
        }
        if ((this.missionData.quiz.q3a === 1 && this.missionData.quiz.q3b === 0) || this.missionData.quiz.q3b === 0) {
          this.missionData.analyse.sec = true;
        }
        if (this.missionData.quiz.q4 === 1) {
          this.missionData.analyse.laitier = true;
        }
        if (this.missionData.quiz.q10a === 1 || this.missionData.quiz.q10b === 1) {
          this.missionData.analyse.feculent = true;
        }
        if (this.missionData.quiz.q12 === 2) {
          this.missionData.analyse.alcool = true;
        }
      }
    },

    mounted() {
      api.get(`patients/${this.mission.patient_id}`)
        .then(res => {
          this.patient = res.data;
        });
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>

<style lang="scss"
       type="text/scss">
  .Question {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
  }
  .Info {
    background-color: #c0c0c0;
    font-size: 19px;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 10px
  }
  .ContextBlockSpec {
    font-size: 18px;
    font-weight: 700;
  }
  .ObjectiveBlockSpec {
    font-size: 18px;
    font-weight: 500;
  }
  .Category {
    margin-top: 25px;
  }
  .v-label {
    font-size: 20px

  }
</style>
